import { farmPlugin } from './index.ts';

export default farmPlugin;
